<!-- start section fund types -->
<section class="FT-fund-types bg-gradient">
  <div class="container">
    <div class="text-center text-white section-head">
      <div class="FT-title">{{ "products.funds-home-title" | translate }}</div>
      <div class="text-big funds-description">
        {{ "products.funds-home-title-description" | translate }}
      </div>
    </div>
    <div class="row gx-0 mb-5 pb-3" *ngIf="isLoaded && fundListingData?.length else loaderBlock">
      <div class="nav flex-column nav-pills me-4 col-auto" id="v-pills-tab" role="tablist" aria-orientation="vertical"
           style="min-width: 239px;">
        <ng-container *ngFor="let element of sideFilterOptions;let i=index;">
          <button class="nav-link mb-custom-small" [id]="element.name"
                  [ngClass]="element.id==1 ? 'active' : ''"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-focus" type="button" role="tab" aria-controls="v-pills-focus"
                  aria-selected="true" (click)="getData($event)">
            {{ element.name === 'All' ? focusTabName : element.name }}
          </button>
        </ng-container>
      </div>
      <div class="tab-content col home-listing-carousel" id="v-pills-tabContent">
        <div class="tab-pane fade show active" id="v-pills-focus" role="tabpanel"
             aria-labelledby="v-pills-focus-tab" tabindex="0">
          <ngx-slick-carousel *ngIf="slideConfig" class="carousel" #slickModal="slick-carousel"
                              [config]="slideConfig">
            <ng-container *ngFor="let fund of fundListingData; let i = index;">
              <div ngxSlickItem class="slide" *ngIf="i < 3">
                <ft-home-fund-card [brConfiguration]="brConfiguration" [fund]="fund"
                                   [hasThreeDotOptions]="true"></ft-home-fund-card>
              </div>
            </ng-container>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
    <ng-template #loaderBlock>
      <div class="text-center mb-5 mt-5">
        <div id="loader">
          <img src="assets/images/home/loader.gif" alt="Loading...">
        </div>
      </div>
    </ng-template>

    <div class="text-center">
      <a *ngIf="selectedAssetClass !=='All Funds'" class="more-links me-5 footer-links-CTA"
         (click)="gotoPage(selectedAssetClass)" style="cursor: pointer;">
        <span>{{ "products.funds-home-explore" | translate }} {{ selectedAssetClass }}</span>
        <img class="right-chev" src="assets/images/general/right-chevron.svg" alt="Right arrow">
      </a>
      <a class="more-links footer-links-CTA" (click)="gotoPage('all funds')" style="cursor: pointer;">
        <span>{{ "products.funds-home-explore-all-funds" | translate }}</span>
        <img class="right-chev" src="assets/images/general/right-chevron.svg" alt="Right arrow">
      </a>
    </div>
  </div>
</section>

